/* eslint-disable react/button-has-type */
import React from 'react';
import { WhatsAppIcon } from '@avila-tek/ui/src';
import Link from 'next/link';
import { useQuery } from '@apollo/client';
import { GET_SETTINGS } from '../../../graphql/queries';
import { Settings } from '../../../models';

function WhatsAppButton() {
  const [whatsAppUrl, setWhatsAppUrl] = React.useState<string>('');
  const [onWhastappHover, setOnWhatsappHover] = React.useState<boolean>(false);
  const { data: dataSettings } = useQuery<{ settings: Settings[] }>(
    GET_SETTINGS,
    {
      fetchPolicy: 'network-only',
    }
  );

  React.useEffect(() => {
    if (dataSettings?.settings) {
      setWhatsAppUrl((dataSettings?.settings as Settings[])[0]?.whatsAppUrl);
    }
  }, [dataSettings]);

  return (
    <div className="relative flex flex-col justify-center items-end">
      {/* Contenedor del mensaje flotante */}
      <div
        className={`fixed bottom-[30px] right-[85px] transform transition-all duration-300 bg-white ${
          onWhastappHover
            ? 'translate-x-0 opacity-100'
            : 'translate-x-full opacity-0'
        } bg-primary text-neutral-cold-500  p-2 rounded-lg shadow-lg`}
      >
        <p>
          Chatea con nosotros{' '}
          <span role="img" aria-label="waving hand">
            👋
          </span>
        </p>
        <div className="absolute w-3 h-3 -right-[6px] top-[14px] bg-white rotate-45" />
      </div>
      {/* Botón de WhatsApp */}
      {whatsAppUrl ? (
        <Link href={`${whatsAppUrl}`} passHref target="blank">
          <button
            type="button"
            onMouseEnter={() => setOnWhatsappHover(true)}
            onMouseLeave={() => setOnWhatsappHover(false)}
            className="fixed bottom-4 right-4 bg-primary text-white rounded-full p-2"
          >
            <WhatsAppIcon />
          </button>
        </Link>
      ) : null}
    </div>
  );
}

export default WhatsAppButton;
